import React from 'react';
import { Link } from 'react-router-dom';

const PRIVACY_CARDS = [
  {
    icon: '🛡️',
    title: 'Datenschutz by Design',
    text: 'Der Schutz sensibler Daten ist fest in die Architektur eingebaut – nicht nachträglich ergänzt, sondern bei jeder KI-Anfrage automatisch aktiv.',
  },
  {
    icon: '🔍',
    title: 'Automatische Pseudonymisierung',
    text: 'E-Mail-Adressen, Telefonnummern und bereits bekannte Namen aus deinem Team werden vor jeder KI-Anfrage automatisch erkannt und durch einen Platzhalter ersetzt.',
  },
  {
    icon: '🔒',
    title: 'Keine Klardaten für die KI',
    text: 'Die KI bekommt diese sensiblen Daten nie im Klartext zu sehen – nur der Platzhalter wird übermittelt, nie der echte Wert.',
  },
  {
    icon: '↩️',
    title: 'Rückübersetzung nach der Antwort',
    text: 'Antwortet die KI mit einem Platzhalter, wird er automatisch zurückübersetzt – du siehst immer die echten Werte, ohne etwas zu tun.',
  },
  {
    icon: '🎙️',
    title: 'Auch für Meetings & Audio',
    text: 'Transkripte und Besprechungsprotokolle werden genauso geschützt. Audiodateien lassen sich zusätzlich optional automatisch nach der Verarbeitung löschen.',
  },
  {
    icon: '👁️',
    title: 'Transparenz für dich',
    text: 'Ein Badge zeigt dir nach jeder Anfrage genau, welche Datentypen erkannt und geschützt wurden – live und nachvollziehbar.',
  },
];

const FLOW_STEPS = ['Deine Eingabe', 'Datenschutz-Layer', 'KI', 'Antwort', 'Rückübersetzung', 'Du'];

function PrivacySection() {
  return (
    <section className="privacy-ki reveal" id="datenschutz-ki">
      <div className="section-header">
        <h2>Datenschutz & KI</h2>
        <p>Personenbezogene Daten schützen, bevor sie eine KI erreichen – automatisch und ohne Zusatzaufwand.</p>
      </div>

      <div className="privacy-ki-grid">
        {PRIVACY_CARDS.map(({ icon, title, text }) => (
          <div key={title} className="privacy-ki-card">
            <div className="privacy-ki-card__icon">{icon}</div>
            <h3>{title}</h3>
            <p>{text}</p>
          </div>
        ))}
      </div>

      <div className="privacy-flow" role="list" aria-label="Ablauf der Pseudonymisierung">
        {FLOW_STEPS.map((step, i) => (
          <React.Fragment key={step}>
            {i > 0 && <span className="privacy-flow__arrow" aria-hidden="true">→</span>}
            <div className="privacy-flow__step" role="listitem">{step}</div>
          </React.Fragment>
        ))}
      </div>
      <p className="privacy-flow__hint">Ausschließlich pseudonymisierte Daten erreichen die KI.</p>

      <p className="privacy-ki-more">
        Mehr Details dazu, welche Daten wir wie lange speichern, findest du in unserer{' '}
        <Link to="/datenschutz">Datenschutzerklärung</Link>.
      </p>
    </section>
  );
}

export default PrivacySection;
